import { render, staticRenderFns } from "./BigscootsCaseStudy.vue?vue&type=template&id=85be0dec&scoped=true"
import script from "./BigscootsCaseStudy.vue?vue&type=script&lang=js"
export * from "./BigscootsCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./BigscootsCaseStudy.vue?vue&type=style&index=0&id=85be0dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85be0dec",
  null
  
)

export default component.exports